import { API, standardResponse } from "./middleware";

export async function searchLayers(dataSearch) {
  return API.post("/api/public/layer/search", dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function fetchLayerCreate(data) {
  return API.post("/api/layer/create", data, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchLayerUpdate(id, data) {
  return API.put(`/api/layer/update/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchLayerToggleStatus(id) {
  return API.put(`/api/layer/changeStatus/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchLayerDelete(id) {
  return API.delete(`/api/layer/delete/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}
